import accessTokenValidator from './accessTokenValidator.js';

const tokenValidator = (function(settings) {
    const _validateAccessToken = accessTokenValidator(settings);
    const _validateIdToken = ()=>{return Promise.resolve();};// eslint-disable-line

    return {
        validateTokens: _validateTokens,
        validateAccessToken: _validateAccessToken,
        validateIdToken: _validateIdToken
    };

    function _validateTokens(user) {
        const accessToken = user.access_token;
        const idToken = user.id_token;
        return _validateAccessToken(accessToken)
        .then(()=>{
            return _validateIdToken(idToken)
            .then(()=>{
                return Promise.resolve(user);
            });
        });
    }
});

export default tokenValidator;
